import { Theme, useMediaQuery } from "@mui/material";
import { matchPath, useLocation } from "react-router";
import { useAppLayout } from "@providers";

export const useInvestmentActionsLayout = () => {
  const { sidebarCollapsed } = useAppLayout();
  const { pathname } = useLocation();

  const isLessSm = useMediaQuery((t: Theme) => t.breakpoints.down("sm"));
  const isLessMd = useMediaQuery((t: Theme) => t.breakpoints.down("md"));
  const isLessLg = useMediaQuery((t: Theme) => t.breakpoints.down("lg"));
  const isLess1000 = useMediaQuery((t: Theme) => t.breakpoints.down(1000));

  const isNarrow = sidebarCollapsed ? isLess1000 : isLessLg;
  const isVeryNarrow = sidebarCollapsed ? isLessSm : isLessMd;

  const canShowCurrencyToggle = !matchPath("/depots/*", pathname);

  return {
    isNarrow,
    isVeryNarrow,
    canShowCurrencyToggle,
  };
};
